import styles from "./index.module.scss";
import { renderRichText } from "@/utils/formatters";
import { useRouter } from "next/router";
import CampaignForm from "@/components/CustomComponents/CampaignForm";

const AppointyForm = ({ appointyData, locale }) => {
  return (
    <section className="c-koh-warranty-registration-form">
      <div className="koh-contact-container">
        {appointyData?.heading && (
          <div className="koh-contact-header">
            <span className="koh-contact-title">
              {renderRichText(appointyData?.heading, locale)}
            </span>
          </div>
        )}
        <div className="koh-contact-form-wrapper">
          {appointyData?.description && (
            <div className="form-group">
              <div className="text-center">
                {renderRichText(appointyData?.description, locale)}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

const KecAppointyForm = ({ appointyData }) => {
  const { locale } = useRouter();

  const { formLink = "" } = appointyData;

  return (
    <div className={styles.wrapper}>
      {formLink ? (
        <CampaignForm appointyData={appointyData} />
      ) : (
        <AppointyForm appointyData={appointyData} locale={locale} />
      )}
    </div>
  );
};

export default KecAppointyForm;
